import React from 'react';
import { Badge, Tooltip } from '@usealloy/component-library';
import { getBadgeType } from '../helpers';

type StatusBadgeProps = {
  status: string;
};

type StatusBadgeTooltipProps = StatusBadgeProps & { children: React.ReactElement };

const StatusTooltipWrapper = ({
  status,
  children,
}: StatusBadgeTooltipProps) => (
  <Tooltip
    content={status}
    side="top"
  >
    {children}
  </Tooltip>
);

const StatusBadge = ({
  status,
}: StatusBadgeProps) => (
  <StatusTooltipWrapper {...{ status }}>
    <Badge status={getBadgeType(status)}>{status}</Badge>
  </StatusTooltipWrapper>
);

export default StatusBadge;
